<script>
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default{
    name: "table-nilai-evaluasi-perencanaan",

    data(){
        return{
            id: this.$route.params.id,
            templateExcel: '/template_excel/template_seminar_perencanaan.xlsx',
            showModal : false,
            pathExcel:false,
            loadingTable:true,
            nilaiPerencanaan: null,
            dataTableSeminarPerencanaan: [],
        }
    },
    mounted(){
       this.getDataTableEvaluasiSeminarPerencanaan(this.id)
    },
    methods:{
    getDataTableEvaluasiSeminarPerencanaan(id) {
      let self = this;
      self.loadingTable = true;

      // get data table evaluasi stula
      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/evaluasi-seminar-perencanaan",
        params: {
          id: id,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config)
        .then(function (response) {
          self.loadingTable = false;

          var response_data = response.data;
          var response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            self.dataTableSeminarPerencanaan = response_data_fix;
          } else {
            self.dataTableSeminarPerencanaan = [];
          }
        })
        .catch(function (error) {
          self.loadingTable = false;
          self.dataTableSeminarPerencanaan = [];
          console.log(error);
        });
    },
    mathSeminarPerencanaan(row_data) {
      const aspekpr1 = parseFloat(row_data.aspekpr1) || 0;
      const aspekpr2 = parseFloat(row_data.aspekpr2) || 0;
      const aspekpr3 = parseFloat(row_data.aspekpr3) || 0;
      const aspekpr4 = parseFloat(row_data.aspekpr4) || 0;
      const aspekpr5 = parseFloat(row_data.aspekpr5) || 0;

      row_data.nilaiPerencanaan = ((aspekpr1 * 0.04) + (aspekpr2 * 0.04) + (aspekpr3 * 0.04) + (aspekpr4 * 0.04) + (aspekpr5 * 0.04)) * 0.2;
      row_data.nilaiPerencanaan = row_data.nilaiPerencanaan.toFixed(2);
    },

    importEvaluasiSeminarPerencanaan() {
      let self = this;
      self.showModal = true;
    },
    
    inputFileExcelPerencanaan() {
      let self = this;
      if ($("#inputExcelEvaluasiPerencanaan")[0].files[0]) {

        let fileName = $("#inputExcelEvaluasiPerencanaan")[0].files[0].name;
        let fileExtension = fileName.split('.').pop().toLowerCase();

        if (fileExtension === 'xlsx') {
          $("#uploadLoadingPerencanaan").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

          var urlres = process.env.VUE_APP_BACKEND_URL;
          var FormData = require("form-data");
          var data = new FormData();
          data.append("file", $("#inputExcelEvaluasiPerencanaan")[0].files[0]);
          var config = {
            method: "post",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
            data: data,
          };
          axios(config).then(function (response) {
            var resStatus = response.status;
            if (resStatus === 200) {
              var path_file = response.data.data.path_file;
              urlres += path_file;
              $("#uploadLoadingPerencanaan").html(
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-check"></i>' +
                'Berhasil' +
                '</span>' +
                '<a href="' + urlres + '" target="_blank" style="padding-left:10px;">' +
                '<span class="badge bg-success p-1">' +
                '<i class="fa fa-eye"></i>' +
                'Lihat File' +
                '</span>' +
                '</a>'
              );

              self.pathExcel = path_file;
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong !',
                showConfirmButton: true,
              });
            }
          });
        } else {
          alert("Format file harus ber-type (XLSX)");
          $('#inputExcelEvaluasiStula').val('');
        }
      }
    },
    exportEvaluasiSeminarPerencanaan() {
      let self = this;

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: 'get',
        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'transactions/penilaian/eksportEvaluasi/seminar-perencanaan',
        params: {
          id: self.id,
        },
        crossdomain: true,
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
        withCredentials: true,
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.close();
          // Download the file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Evaluasi Nilai Seminar Perencanaan.xlsx'); // Update filename if needed
          document.body.appendChild(link);
          link.click();
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n' + error,
          showConfirmButton: true
        });
      });
    },
    storeImportEvaluasiSeminarPerencanaan() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: "post",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/importEvaluasi/seminar-perencanaan",
        data: {
          id: self.id,
          path_excel: self.pathExcel
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token
        }
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Success upload data !',
            showConfirmButton: true,
          });

          self.showModal = false;
          $("#inputExcelEvaluasiPerencanaan").val('');
          self.getDataTableEvaluasiSeminarPerencanaan(self.id);
          $("#uploadLoadingPerencanaan").empty();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Something went wrong :)',
            showConfirmButton: true,
          });
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n ' + error,
          showConfirmButton: true,
        });
      });
    },

    }
}
</script>
<template>
    <div class="row mt-3 mb-2">
        <div class="col-12">
        <div class="card-title">Evaluasi Seminar Perencanaan</div>
        </div>
    </div>

    
    <div class="row mb-3">
        <div class="col-12 text-end">
        <b-button variant="info" size="sm" @click="importEvaluasiSeminarPerencanaan()">
            <i class="fas fa-upload"></i>
            &nbsp;
            <b>Import Evaluasi Seminar Perencanaan</b>
        </b-button>
        &nbsp;
        <b-button variant="info" size="sm" @click="exportEvaluasiSeminarPerencanaan()">
            <i class="fas fa-file-excel"></i>
            &nbsp;
            <b>Export Evaluasi Seminar Perencanaan</b>
        </b-button>
        </div>
    </div>

    <div class="col-12 table-responsive pb-3">
        <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
        <thead class="orangeTheme align-middle">
            <tr>
            <th class="text-center" rowspan="3">No. Absen</th>
            <th class="text-center" rowspan="3">Nama Peserta</th>
            <th class="text-center" rowspan="3">Instasi Peserta</th>
            <th class="text-center" colspan="11">Aspek</th>
            </tr>
            <tr>
            <th class="text-center" colspan="2">Ketepatan Rencana Aksi Perubahan</th>
            <th class="text-center" colspan="2">Terobosan Inovatif</th>
            <th class="text-center" colspan="2">Tahapan Rencana Perubahan dan Pengendalian Resiko</th>
            <th class="text-center" colspan="2">Kejelasan Peta dan Pemanfaatan Sumberdaya Organisasi</th>
            <th class="text-center" colspan="2">Rencana Strategi Pengembangan Kompetensi Dalam Aksi Perubahan</th>
            <th class="text-center">Nilai Perencanaan Aksi Perubahan PKA</th>
            </tr>
            <tr>
            <th class="text-center" style="min-width: 100px;">
                &nbsp;
            </th>
            <th class="text-center">4%</th>
            <th class="text-center" style="min-width: 100px;">
                &nbsp;
            </th>
            <th class="text-center">4%</th>
            <th class="text-center" style="min-width: 100px;">
                &nbsp;
            </th>
            <th class="text-center">4%</th>
            <th class="text-center" style="min-width: 100px;">
                &nbsp;
            </th>
            <th class="text-center">4%</th>
            <th class="text-center" style="min-width: 100px;">
                &nbsp;
            </th>
            <th class="text-center">4%</th>
            <th class="text-center">20%</th>
            </tr>
        </thead>
        <tbody class="align-top">
            <tr v-if="loadingTable == true">
            <td colspan="30">
                <i class="fas fa-spin fa-spinner"></i>
                &nbsp;
                <span>loading . . .</span>
            </td>
            </tr>
            <tr v-else-if="dataTableSeminarPerencanaan == ''">
            <td colspan="30" class="text-center">
                -- Data Kosong --
            </td>
            </tr>
            <tr v-else v-for="(row_data1, key_data1) in dataTableSeminarPerencanaan" :key="key_data1" class="align-middle">
            <td class="text-center">{{ key_data1 + 1 }}</td>
            <td>{{ row_data1.user.name }}</td>
            <td>Smartsoft</td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name">
                {{ row_data1.aspekpr1 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name"> {{ row_data1.percent_aspekpr1 }}</span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name">
                {{ row_data1.aspekpr2 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name"> {{ row_data1.percent_aspekpr2 }}</span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name">
                {{ row_data1.aspekpr3 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name"> {{ row_data1.percent_aspekpr3 }}</span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name">
                {{ row_data1.aspekpr4 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name"> {{ row_data1.percent_aspekpr4 }}</span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name">
                {{ row_data1.aspekpr5 }}
                </span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name"> {{ row_data1.percent_aspekpr5 }}</span>
            </td>
            <td class="text-center">
                <span class="numberHover" :title="row_data1.user.name">
                {{ row_data1.nilai_perencanaan }}
                </span>
            </td>
            </tr>
        </tbody>
        </table>
    </div>

    <b-modal v-model="showModal" title="Import Evaluasi Seminar Perencanaan" title-class="text-black font-18" body-class="p-3" hide-footer>
    <form @submit.prevent="storeImportEvaluasiSeminarPerencanaan()">
      <div class="row mt-2">
        <div class="col-12 text-end">
          <a :href="templateExcel" target="_blank" class="btn btn-sm btn-success" style="border-bottom-left-radius: 0px !important; border-bottom-right-radius: 0px !important;">
            <i class="fas fa-download"></i>
            &nbsp;
            <span><b>Download Template</b></span>
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <input type="file" class="form-control" id="inputExcelEvaluasiPerencanaan" placeholder="Masukkan File Excel . . ." v-on:change="inputFileExcelPerencanaan()" accept=".xlsx" style="border-top-right-radius: 0px !important;">
        </div>
        <div class="col-12">
          <div class="respond-input-file float-left" id="uploadLoadingPerencanaan"></div>
        </div>
      </div>

      <div class="row mt-3 mb-2">
        <div class="col-12">
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-end">
          <b-button variant="primary" type="submit">
            <i class="fas fa-check"></i>
            &nbsp;
            <span><b>Simpan</b></span>
          </b-button>
        </div>
      </div>
    </form>
  </b-modal>
</template>